module.exports = ".spinner-container {\n  position: fixed;\n  z-index: 999;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  width: 64px;\n  height: 128px; }\n  .spinner-container .loading-spinner {\n    width: 64px !important;\n    height: 64px !important; }\n  .spinner-container .loading-spinner /deep/ svg {\n      width: 64px !important;\n      height: 64px !important; }\n  .spinner-container .loading-spinner /deep/ svg circle {\n        stroke: rgba(0, 0, 0, 0.2); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading.component.scss
// module id = ./src/app/shared/loading.component.scss
// module chunks = main